/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BooleanResponse } from '../models/boolean-response';
import { createProfileSubscription } from '../fn/profile-subscription-management/create-profile-subscription';
import { CreateProfileSubscription$Params } from '../fn/profile-subscription-management/create-profile-subscription';
import { deleteProfileSubscription } from '../fn/profile-subscription-management/delete-profile-subscription';
import { DeleteProfileSubscription$Params } from '../fn/profile-subscription-management/delete-profile-subscription';
import { listProfileSubscriptions } from '../fn/profile-subscription-management/list-profile-subscriptions';
import { ListProfileSubscriptions$Params } from '../fn/profile-subscription-management/list-profile-subscriptions';
import { ProfileSubscription } from '../models/profile-subscription';
import { updateProfileSubscription } from '../fn/profile-subscription-management/update-profile-subscription';
import { UpdateProfileSubscription$Params } from '../fn/profile-subscription-management/update-profile-subscription';

@Injectable({ providedIn: 'root' })
export class ProfileSubscriptionManagementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listProfileSubscriptions()` */
  static readonly ListProfileSubscriptionsPath = '/rest/admin/profile/{id}/subscription';

  /**
   * List all subscriptions assigned to profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileSubscriptions$Response(params: ListProfileSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileSubscription>>> {
    return listProfileSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * List all subscriptions assigned to profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileSubscriptions(params: ListProfileSubscriptions$Params, context?: HttpContext): Observable<Array<ProfileSubscription>> {
    return this.listProfileSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileSubscription>>): Array<ProfileSubscription> => r.body)
    );
  }

  /** Path part for operation `createProfileSubscription()` */
  static readonly CreateProfileSubscriptionPath = '/rest/admin/profile/{id}/subscription';

  /**
   * Create new subscription for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProfileSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProfileSubscription$Response(params: CreateProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
    return createProfileSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new subscription for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProfileSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProfileSubscription(params: CreateProfileSubscription$Params, context?: HttpContext): Observable<ProfileSubscription> {
    return this.createProfileSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileSubscription>): ProfileSubscription => r.body)
    );
  }

  /** Path part for operation `updateProfileSubscription()` */
  static readonly UpdateProfileSubscriptionPath = '/rest/admin/profile/{id}/subscription/{profileSubscriptionId}';

  /**
   * Update existing subscription for profile. Profile cannot be changed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfileSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileSubscription$Response(params: UpdateProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
    return updateProfileSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing subscription for profile. Profile cannot be changed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfileSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileSubscription(params: UpdateProfileSubscription$Params, context?: HttpContext): Observable<ProfileSubscription> {
    return this.updateProfileSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileSubscription>): ProfileSubscription => r.body)
    );
  }

  /** Path part for operation `deleteProfileSubscription()` */
  static readonly DeleteProfileSubscriptionPath = '/rest/admin/profile/{id}/subscription/{profileSubscriptionId}';

  /**
   * Delete existing subscription for profile - deleted can be only ACTIVE or FUTURE subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProfileSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileSubscription$Response(params: DeleteProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return deleteProfileSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing subscription for profile - deleted can be only ACTIVE or FUTURE subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProfileSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileSubscription(params: DeleteProfileSubscription$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.deleteProfileSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

}
